<template>
  <!-- ============================================================
       No.9 代行者権限付与：招待リンクからの初回パスワード設定
       事前作成済みの代行者アカウント(user_type=3)にパスワードを設定する。
       ============================================================ -->
  <div id="AgentRegisterForm" class="wrap" v-if="!isLoadingNow">
    <div class="formWrap" v-if="!hasSend">
      <h1 class="title">パスワードの設定</h1>
      <b-form>
        <div class="inputBox">
          <p class="lead">代行者アカウントの初回パスワードを設定してください。</p>
          <b-row class="textBase">
            <b-col sm="4" class="labelWrap">
              <label>メールアドレス<br>(ログインID)</label>
            </b-col>
            <b-col sm="5" class="textData">
              {{ mailAdress }}
            </b-col>
          </b-row>
          <span class="guide">
            英大文字・英小文字・数字・記号をそれぞれ1つ以上利用し8文字以上入力してください。
          </span>
          <v-form-text
            label="パスワード"
            type="password"
            itemStyle="line"
            :errMessage="errors.password || []"
            v-model="inputData.password"
            maxLength="255"
            @check="passCheck"
          >
          </v-form-text>
          <v-form-text
            label="パスワードの確認"
            type="password"
            itemStyle="line"
            :errMessage="errors.password_twice || []"
            v-model="inputData.passwordConf"
            maxLength="255"
            @check="passCheck"
          >
          </v-form-text>
        </div>
        <b-alert
          class="errorWrap"
          :show="typeof errors.errorMessage !== 'undefined'"
          variant="warning">{{ errors.errorMessage }}</b-alert>
        <b-button
          class="regist"
          :disabled="hasPassErr || !inputData.password || !inputData.passwordConf"
          @click="send"
        >
          設定する
        </b-button>
      </b-form>
    </div>
    <div class="end" v-if="hasSend">
      <h1>パスワードを設定しました</h1>
      <b-button
        class="btn fw-6"
        @click="$router.push({ name: 'gasLogin' })"
      >
        ログイン画面へ
      </b-button>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api';

export default {
  name: 'AgentRegisterForm',
  data() {
    return {
      mailAdress: null,
      inputData: {
        password: null,
        passwordConf: null,
      },
      errors: [],
      isLoadingNow: true,
      hasSend: false,
      hasPassErr: false,
    };
  },
  async created() {
    this.$store.dispatch('page/onWaiting');
    const { uuid } = this.$route.params;
    const res = await api.send('/api/agent/register/getMailAddress', { uuid })
      .catch((error) => {
        console.log(error);
        this.$router.push({ name: 'gasLogin' });
        return false;
      });
    if (res !== false) {
      this.mailAdress = res.data.mailAddress;
      this.isLoadingNow = false;
    }
    this.$store.dispatch('page/offWaiting');
  },
  methods: {
    async send() {
      this.$store.dispatch('page/onWaiting');
      const { uuid } = this.$route.params;
      const params = {
        uuid,
        password: this.inputData.password,
        password_twice: this.inputData.passwordConf,
      };
      const res = await api.send('/api/agent/register/savePassword', params)
        .catch((error) => {
          this.errors = error.response.data.message;
          return false;
        });
      if (res !== false) {
        this.hasSend = true;
      }
      this.$store.dispatch('page/offWaiting');
    },
    passCheck() {
      this.$delete(this.errors, 'password_twice');
      this.hasPassErr = false;
      if (!this.inputData.password || !this.inputData.passwordConf) {
        return true;
      }
      if (this.inputData.password !== this.inputData.passwordConf) {
        this.$set(this.errors, 'password_twice', ['パスワードの確認とパスワードが一致するよう入力してください。']);
        this.hasPassErr = true;
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.title {
  margin-top: 112px;
  margin-bottom: 37px;
  color: #333333;
  font-weight: 600;
  font-size: 24px;
}
.formWrap {
  text-align: center;
}
.inputBox {
  width: 700px;
  margin: 0 auto;
  padding-bottom: 27px;
  border-bottom: solid 1px #CCCCCC;
}
.lead {
  margin-bottom: 24px;
}
.textBase {
  text-align: left;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  align-items: center;
  margin: 15px auto;
}
.textBase label,
.textBase .labelWrap {
  width: 237px;
  max-width: 237px;
  font-weight: bold;
}
.textBase .textData {
  padding-left: 20px;
}
.regist,
.end button.btn {
  background-color: #122889 !important;
  color: #FFFFFF !important;
  font-size: 18px;
  font-weight: 600;
  margin: 10px;
}
.end {
  width: 280px;
  margin: auto;
  margin-top: 32.8vh;
  text-align: center;
}
.end h1 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 46px;
}
span.guide {
  margin-left: 271px;
  display: block;
  text-align: left;
  width: 400px;
  font-size: 13px;
  margin-bottom: -11px;
}
</style>
<style>
  #AgentRegisterForm .errorWrap {
    width: 700px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
</style>
